import React, { Component } from "react";
import { API } from "aws-amplify";
import {  Form, Row, Col, Card, Modal, Alert, Nav, Button  } from "react-bootstrap";

import 'react-table/react-table.css';
import { LinkContainer } from "react-router-bootstrap";
import Select from 'react-select';
import 'containers/common/Detail.css';
import { PacmanLoader } from 'react-spinners';
//import SLMAgentList from "../containers/SLMAgentList"; //new
import SLMEntityContactList from "containers/slm/SLMEntityContactList";

export default class SLMEntityDetail extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);   
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this); 

        this.state = {
            isLoading: null,
            isDeleting: null,
            entity: null,
            modified: false,
            showAlert: false,
            errorMessage: "",

            idList: [],
            previousId: null,
            nextId: null,
            currentIdIndex: null,
            entityContacts : [],
            stateOptions: [],
            selectedPhysState: null,
            selectedMainState: null,
          //  entityOptions: null, // dont know if need this yet
            entityContactFilter: { orgid: parseInt(this.props.match.params.id)},                 
            entity_org_id: null,
            sale_id: null,
            lease_id: null,
            name: null,
            name_key: null,
            mail_street: null,
            mail_state: null,
            mail_suburb: null,
            mail_code: null,
            phys_street: null,
            phys_state: null,
            phys_suburb: null,
            phys_code: null,
            phone_ext: null,
            phone_no: null,
            phone: null,
            fax_ext: null,
            fax_no: null,
            email: null,
            web: null,
            notes: null,
            created_date: null,
            created_by: null,
            last_edited_date: null,
            last_edited_by: null

           
        };
                      

    }
    
     

    componentWillUnmount() {
        this.setState({ entity: [] });
     //   this.setState({ entityOptions: [] });

        
        }

    async componentDidMount() {
        try {
            this.setState({ isLoading: true });
            console.log(this.props.match.params.id );
            if (this.props.match.params.id == "new") {
                console.log("New entity");
                await this.syncroniseState();
                
                document.title = "New entity record";
                

            }
            else {
                await this.retrieveEntity();
                if (this.props.location.state){
                    if (this.props.location.state.hasOwnProperty("data")){
                        const idList = this.props.location.state.data;
                        const currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id,10));
                        
                        let nextId = null;
                        let previousId = null;
                        
                        if (currentIdIndex+1 < idList.length){
                            nextId = idList[currentIdIndex+1];
                            
                        }
                        if (currentIdIndex >0){
                            previousId = idList[currentIdIndex-1];                            
                        }
                        this.setState({idList: idList,nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex});
                    }
                }

                try {
                    this.state.entity && this.getEntityContacts(this.state.entityContactFilter);
                }
                catch{
                    alert("Error loading entity contacts");
                }

                document.title = this.state.name;
                
            }
            
            this.setState({ selectedPhysState: { value: this.state.phys_state, label: this.state.phys_state } });
            this.setState({ selectedMailState: { value: this.state.mail_state, label: this.state.mail_state } });
            this.getStates({});


         //   this.setState({ selectedSuburb: { value: this.state.suburb, label: this.state.suburb } });
         //   const suburbOptions = await this.getSuburbs();
         //   if (suburbOptions) {
         //       this.setState({ suburbOptions });
         //   }

            

            
            this.setState({ isLoading: false });

        } catch (e) {
            alert(e);
        }
    }

   

    async syncroniseState() {
        const entity = {
            entity_org_id: this.state.entity_org_id,
            sale_id: this.state.sale_id,
            lease_id: this.state.lease_id,
            name: this.state.name,
            name_key: this.state.name_key,
            mail_street: this.state.mail_street,
            mail_suburb: this.state.mail_suburb,
            mail_code: this.state.mail_code,
            mail_state: this.state.mail_state,
            phys_street: this.state.phys_street,
            phys_state: this.state.phys_state,
            phys_suburb: this.state.phys_suburb,
            phys_code: this.state.phys_code,
            phone_no: this.state.phone_no,
            phone_ext: this.state.phone_ext,
            fax_ext: this.state.fax_ext,
            fax_no: this.state.fax_no,
            email: this.state.email,
            web: this.state.web,
            notes: this.state.notes,
            created_date: this.state.created_date,
            created_by: this.state.created_by,
            last_edited_date: this.state.last_edited_date,
            last_edited_by: this.state.last_edited_by
           
        };

        this.setState({ entity });

    }

    async retrieveEntity() {
        const entity = await this.getEntity();
        console.log(entity)
        const { entity_org_id,
            sale_id,
            lease_id,
            name,
            name_key,
            mail_street,
            mail_state,
            mail_suburb,
            mail_code,
            phys_street,
            phys_state,
            phys_suburb,
            phys_code,
            phone_ext,
            phone_no,
            phone,
            fax_ext,
            fax_no,
            email,
            web,
            notes,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by } = entity;

        this.setState({
            entity,
            entity_org_id,
            sale_id,
            lease_id,
            name,
            name_key,
            mail_street,
            mail_state,
            mail_suburb,
            mail_code,
            phys_street,
            phys_state,
            phys_suburb,
            phys_code,
            phone_ext,
            phone_no,
            phone,
            fax_ext,
            fax_no,
            email,
            web,
            notes,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by                  
        });
    }

    async getEntity(filter) {
        console.log("api run")
        const response = API.get("colin", `/slmentities/${this.props.match.params.id}`, { 'queryStringParameters': filter });
        try {
            return await response;

        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        };
       // return API.get("colin", `/slmentities/${this.props.match.params.id}`);
    }

  
    async saveEntity(entity) {
        
        this.setState({ last_edited_by: this.props.user });
        if (this.props.match.params.id === "new" && this.state.entity_org_id === null) {
            this.setState({ created_by: this.props.user });
            const response =  await API.post("colin", `/slmentities/new`, { body: entity });
            try {
                return await response;
    
            } catch (error) {
                alert(error+". Please refresh the page (F5) to try again.")
            };
        }
        const response =  API.put("colin", `/slmentities/${this.state.entity_org_id}`, { body: entity  });
        try {
            return await response;

        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        };
    }

  
    getStates(filter) {
        try {
            API.get("colin", `/slmstates`, { 'queryStringParameters': filter }).then((stateOptions) => {
                if (stateOptions) {
                    this.setState(state => ({ stateOptions }));
                }
            });
        }
        catch{
            console.log("Error getting states");
        }
    }

    getEntityContacts(filter) {
        try {
            API.get("colin", "/slmentities/${this.state.entity_org_id}/slmcontacts" , { 'queryStringParameters': filter}).then((entityContacts) => {
                if (entityContacts) {
                    this.setState(state => ({ entityContacts }));
                }
            }
            );
        }
        catch{
            console.log("Error getting entityContacts");
        }
    
    }

   

     //new
     async updateTableState(data, set) {
        this.setState({
            [set]: data
        });
        return true;
    }
    //new
    saveRecord(record, endpoint, id) {
        console.log(record);
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;             
                return API.post("colin", `/slmentities/${this.state.entity_org_id}/slmcontacts/new`, {
                    body: record
                });
                
            }
        }
        return API.put("colin", `/slmentities/${this.state.entity_org_id}/slmcontacts/${record[id]}`, {
            body: record
        });   
    }

    deleteRecord(endpoint, params) {
        return API.del("colin", `/${endpoint}`, { 'queryStringParameters': params });
    };

    validateRelatedRecord(record, set) {
        //address
        if (set === "entity") {

            
            if (this.state.phys_state === null ) {
                return [false, "Street Address State is a required field. CHANGES TO THIS RECORD WILL NOT BE SAVED until Street Address State is filled."];
            }

            if (this.state.name === null ) {
                return [false, "You must enter a name"];
            }
            
          
            


        }

        


        return [true,""];
    }

    handleEnterCurrentIdIndex = event =>{
        if(event.keyCode === 13 || event.keyCode === 9 ){
           this.handleGoToRecord();
        }
   }

    handleGoToRecord = event => {
        console.log(this.state.idList.length);
        if(this.state.currentIdIndex>=0 && this.state.currentIdIndex < this.state.idList.length){
            this.props.history.push({pathname:`/slmleases/${this.state.idList[this.state.currentIdIndex]}`, state:{data: this.state.idList}});
        }
        else{
            alert("Page no not in range.");
        }
    }

    handleCurrentIdIndexChange =event =>{
        const val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({[event.target.id]: val-1});        
    }

    handleChange = event => {
        
        this.setState({ [event.target.id]: event.target.value });        
        this.setState({ modified: true });

    }

    handlePercentChange = event => {
        let val = event.target.value.replace(/[^0-9.%]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }

    handleNumberChange = event => {
        let val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }

    handleDateChange(date, name) {
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(date);
        const today =new Date();        
     
        if(name==="print_month"){
            if (dt.getTime()<today.getTime()  )
            {
                alert("Delivery date cannot be earlier than today");
                return
            }
        }
        if (date) {
            this.setState({
                [name]: dt.toLocaleDateString('en-AU',options)
                , modified: true
            },this.handleBlur);
        }
        this.setState({ modified: true });
    }


    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        },this.handleBlur)
        this.setState({ modified: true });

    }

    handlePhysStateChange = (selectedPhysState) => {
        if(selectedPhysState){
            this.setState({ selectedPhysState });
            this.setState({ phys_state: selectedPhysState.value, modified: true});
        }
        else{
            this.setState({ selectedPhysState: {value: null, label: null} });
            this.setState({ phys_state: null, modified: true});
        }
    }
    
    handleMailStateChange = (selectedMailState) => {
        if(selectedMailState){
            this.setState({ selectedMailState });
            this.setState({ mail_state: selectedMailState.value, modified: true});
        }
        else{
            this.setState({ selectedMailState: {value: null, label: null} });
            this.setState({ mail_state: null, modified: true});
        }
    }

    handleBlur = async event => {
        
        if (this.state.modified === true) {  
                    
            this.setState({ showAlert: false, last_edited_by: this.props.user });
            const result = await this.syncroniseState();
            const validation = this.validateRelatedRecord(this.state.entity, "entity");
            if (validation[0] === true) {
                if(validation[1]!==""){
                    this.setState({ errorMessage: validation[1] });
                    this.setState({ showAlert: true });
                }
                try {
                    this.setState(state => ({ modified: false }));
                    if (this.props.match.params.id === "new") {
                        this.setState({ isLoading: true });
                    }
                    console.log("Saving entity");
                    const result = await this.saveEntity(this.state.entity);
                    this.setState({ isLoading: false });
                    console.log(result);
                    if (result.result === false) {
                        
                        alert(result.error_message);
                    }
                    else {
                       
                        if (this.props.match.params.id === "new") {
                            this.setState(state => ({ entity_org_id: result.id }));                            
                            this.props.history.push("/slmentities/" + result.id);
                        }
                    }
                } catch (e) {
                    alert(e);
                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }
        }
    }

    deleteEntity() {
        return API.del("colin", `/slmentities/${this.props.match.params.id}`);
     }

    handleDelete = async event => {
        event.preventDefault();

        const confirmed = window.confirm(
            "Are you sure you want to delete this entity?"
        );

        if (!confirmed) {
            return;
        }

        this.setState({ isDeleting: true });

        try {
            await this.deleteLease();
            this.props.history.push("/");
        } catch (e) {
            alert(e);
            this.setState({ isDeleting: false });
        }
    }
   

    handleSuburbChange = (selectedSuburb) => {
        this.setState({ selectedSuburb });
    }

    render() {
        return (
            <div className="Entity">
                {this.state.isLoading &&
                    <div className="outer-div"><div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css="display: block;
                            margin: 0 auto;
                             border-color: red"
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                        />
                </div>
                    </div>}
                {this.state.entity && this.props.isAuthenticated && !this.state.isLoading &&
                    <Form  >
                        <Modal show={this.state.showAlert && this.state.lease_id? true: false} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                                <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                                <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                            </Modal>
                            {this.state.showAlert && !this.state.lease_id &&
                            <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                            <Form.Row>
                            <Col sm={4} md={4} lg={4} > 
                                <h6>
                                Entity Details - {this.state.name} | {(this.state.building_name || "")}
                                </h6>
                            </Col>
                            <Col>
                                <Nav className="justify-content-center " >
                                {this.state.previousId!== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/slmentities/${this.state.previousId}`, state:{data: this.state.idList}}} >
                                            <Button type="button" variant="info"  size="sm">Previous</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                   
                                    {this.state.nextId!== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/slmentities/${this.state.nextId}`, state:{data: this.state.idList}}} >
                                            <Button type="button" variant="info"  size="sm">Next</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                    {this.state.currentIdIndex!==null && this.state.idList.length>0 &&
                                        <Form.Group as={Row} controlId="currentIdIndex" >     
                                        <Col className="zeroPadRight">
                                            <Form.Control
                                                onChange={this.handleCurrentIdIndexChange}
                                                value={this.state.currentIdIndex+1}
                                                as="input"
                                                type="text"
                                                min="0"
                                                className="pageCount"
                                                onBlur={this.handleGoToRecord}
                                                onKeyDown={this.handleEnterCurrentIdIndex}
                                            />
                                            </Col>                               
                                            <Col  className="zeroPadLeft">
                                            <h6><div className="topPad">of {this.state.idList.length} {" "}</div></h6>
                                            </Col>
                                            
                                        </Form.Group>
                                         
                                    }
                                    </Nav>
                                </Col>
                            
                            <Col >
                             <Nav className="justify-content-end " >    
                             <Nav.Item  >  
                                {/* <a href={`/slmleases/new`}><Button variant="primary" size="sm" type="button" >New Lease</Button></a>{" "} <br/><br/>                             */}
                                
                                </Nav.Item>                         
                                <Nav.Item  >  
                                {/* <a href={`/slmaddresses/${this.state.address_id}`}><Button variant="primary" size="sm" type="button" >Back to Address</Button></a>{" "} <br/><br/>                             */}
                                {/* <Button  variant="danger" type="button"  onClick={this.handleDelete} size="sm" >Delete Address</Button> */}
                                </Nav.Item>
                            </Nav> 
                            </Col>


                        </Form.Row>
                        <Form.Row>
                        <Col>
                            <Card id="entitydetails">
                                <Card.Header>                    
                                        Entity Details  
                                </Card.Header>
                                 <Card.Body>

                                               
                                    <Form.Group as={Row} controlId="entity_org_id">
                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Entity ID</Form.Label>
                                        <Col>
                                               <Form.Control
                                                disabled
                                                readOnly
                                                onChange={this.handleChange}
                                                value={this.state.entity_org_id}
                                                type="text"

                                               />
                                               </Col>
                   
                                        </Form.Group>

                                        



                                        <Form.Group as={Row} controlId="name">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Name</Form.Label>
                                        <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.name}
                                                    type="text"
                                                    onBlur={this.handleBlur}

                                                /></Col>
                         
                                        </Form.Group>

                                        <Form.Group as={Row} >
                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Telephone</Form.Label>
                                        <Col>
                                               <Form.Control
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChange}
                                                value={this.state.phone_ext}
                                                type="text"
                                                id="phone_ext"

                                               />
                                               </Col>
                   
                                        
                                        <Col>
                                               <Form.Control
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChange}
                                                value={this.state.phone_no}
                                                type="text"
                                                id="phone_no"

                                               />
                                               </Col>
                   
                                        </Form.Group>

                                        <Form.Group as={Row} >
                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Fax</Form.Label>
                                        <Col>
                                               <Form.Control
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChange}
                                                value={this.state.fax_ext}
                                                type="text"
                                                id="fax_ext"

                                               />
                                               </Col>
                   
                                        
                                        <Col>
                                               <Form.Control
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChange}
                                                value={this.state.fax_no}
                                                type="text"
                                                id="fax_no"

                                               />
                                               </Col>
                   
                                        </Form.Group>
                                  
                                        <Form.Group as={Row} controlId="web">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Website</Form.Label>
                                        <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.web}
                                                    type="text"
                                                    onBlur={this.handleBlur}

                                                /></Col>
                         
                                        </Form.Group>

                                        <Form.Group as={Row} controlId="email">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Email</Form.Label>
                                        <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.email}
                                                    type="text"
                                                    onBlur={this.handleBlur}

                                                /></Col>
                         
                                        </Form.Group>
                                        
                             
                           </Card.Body>
                         </Card >

                        </Col>
                        <Col>
                            <Card >
                                    <Card.Header>                    
                                            Street Address  
                                    </Card.Header>
                                    <Card.Body>
                                    <Form.Group as={Row} controlId="phys_street">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Street Address</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                            value={this.state.phys_street}
                                                    type="text"
                                                    onBlur={this.handleBlur}

                                                /></Col>
                         
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="phys_suburb">
                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Suburb</Form.Label>
                                            <Col>
                                        <Form.Control
                                            onChange={this.handleChange}
                                            value={this.state.phys_suburb}
                                            type="text"
                                            onBlur={this.handleBlur}
                                        /></Col>

                                    </Form.Group>

                                    <Form.Group as={Row} controlId="phys_state">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>State</Form.Label>
                                        <Col>

                                        <Select
                                                    value={this.state.selectedPhysState}
                                                    onChange={this.handlePhysStateChange}
                                                    options={this.state.stateOptions}
                                                    onInputChange={this.handleInputChange}
                                                    onBlur={this.handleBlur}
                                                    
                                                />


                                                {/* <Form.Control
                                                    onChange={this.handleChange}
                                                value={this.state.phys_state}
                                                    type="text"
                                                    onBlur={this.handleBlur}

                                                /> */}
                                                
                                                </Col>
                                
                                        </Form.Group>

                                        <Form.Group as={Row} controlId="phys_code">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Postcode</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.phys_code}
                                                    type="text"
                                                    onBlur={this.handleBlur}

                                                /></Col>
                             
                                        </Form.Group>
                                    </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card >
                                    <Card.Header>                    
                                            Postal Address  
                                    </Card.Header>
                                    <Card.Body>

                                    <Form.Group as={Row} controlId="mail_street">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Postal Address</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                            value={this.state.mail_street}
                                                    type="text"
                                                    onBlur={this.handleBlur}

                                                /></Col>
                         
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="mail_suburb">
                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Suburb</Form.Label>
                                            <Col>
                                        <Form.Control
                                            onChange={this.handleChange}
                                            value={this.state.mail_suburb}
                                            type="text"
                                            onBlur={this.handleBlur}
                                        /></Col>

                                    </Form.Group>

                                    <Form.Group as={Row} controlId="mail_state">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>State</Form.Label>
                                        <Col>
                                        <Select
                                                    value={this.state.selectedMailState}
                                                    onChange={this.handleMailStateChange}
                                                    options={this.state.stateOptions}
                                                    onInputChange={this.handleInputChange}
                                                    onBlur={this.handleBlur}
                                                    
                                                />

                                                {/* <Form.Control
                                                    onChange={this.handleChange}
                                                value={this.state.mail_state}
                                                    type="text"
                                                    onBlur={this.handleBlur}

                                                /> */}
                                                </Col>
                                
                                        </Form.Group>

                                        <Form.Group as={Row} controlId="mail_code">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Postcode</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.mail_code}
                                                    type="text"
                                                    onBlur={this.handleBlur}

                                                /></Col>
                             
                                        </Form.Group>


                                    </Card.Body>
                            </Card>
                        </Col>

                        <Col>
                            <Card >
                            <Card.Header>                    
                                    Notes 
                            </Card.Header>
                            <Card.Body>
                            <Form.Group as={Row} controlId="notes">
                                     {/* <Form.Label >Notes</Form.Label> */}
                                     
                                         <Form.Control
                                             onChange={this.handleChange}
                                             value={this.state.notes}
                                             as="textarea"
                                             type="text"
                                             rows="10"
                                             onBlur={this.handleBlur}
                                         />
                                  
                                 </Form.Group>
                            </Card.Body>
                            </Card>
                        </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col>
                            <SLMEntityContactList
                                 
                                    isAuthenticated={this.props.isAuthenticated}
                                    controlType="table"
                                    data={this.state.entityContacts}
                                    updateTableState={this.updateTableState}
                                    saveRecord={this.saveRecord}
                                    deleteRecord={this.deleteRecord}
                                    entityorgid={this.state.entity_org_id}
                                    validateRelatedRecord={this.validateRelatedRecord}
                                    
                                />
                                </Col>
                        </Form.Row>

                    
                       


                      

                    </Form>}
            </div>
        );
    }
}